import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['header', 'cta', 'reasonsModalMessage']> =
	defineContent({
		default: {
			header: {
				id: 'growth.recommendation-jsw-visualize-work.product-name.header',
				description: 'Header for Jira recommendation message in Jira Side Nav',
				defaultMessage: 'Visualize your projects in lists, boards, and more',
				role: 'title',
			},
			cta: {
				id: 'growth.recommendation-jsw-visualize-work.cta.label',
				description: 'CTA text for Jira recommendation message in Jira Side Nav',
				defaultMessage: 'Try Jira',
			},
			reasonsModalMessage: {
				id: 'growth.recommendation-jsw-visualize-work.reasons-modal.message',
				defaultMessage:
					"We think {product} will improve your team's productivity. The recommendation is based on:",
				description:
					'Explanation of why we think the Jira recommendation will be relevant to the customer.',
				role: 'description',
			},
		},
	});
